import React, { Component } from 'react'
import { connect } from 'react-redux'

import { logged, notLoggedIn, closedModalLogin } from '../../store/actions/user'

import Helmet from 'react-helmet'
import Topbar from '../../SPRINTA/Topbar'
import Footer from '../../SPRINTA/Footer'
import T from '../../SPRINTA/translate/T'

class Template extends Component {

    constructor(props) {
        super(props)
        T.handleUpdate(() => {
            this.forceUpdate()
        })
    }

    handleLogin(response) {
        if(response.status === 'loading') return

        if(response.logged)
            this.props.logged(response.data)
        else
            this.props.notLoggedIn()
    }


    render() {
        return (
            <div>
                <Topbar
                    language={T.getLanguage()}
                    handleLogin={ response => this.handleLogin( response ) }
                    modalOpened={ this.props.user.modalLogin ? 'modal-login' : null }
                    handleModalClose={ (ref) => { this.props.closedModalLogin() } }
                />

                <Helmet>
                    <title>SPRINTA</title>
                    <meta property="og:locale" content="pt_BR"/>
                    <meta property="og:url" content={`www.sprinta.com.br`}/>
                    <meta property="og:title" content={`SPRINTA | Loucos por esportes`}/>
                </Helmet>

                { this.props.children }

                <Footer
                    lang={T.getLanguage()}
                    handleLangChanged={lang => {
                        T.setLanguage(lang)
                    }}
                />
            </div>
        )
    }
}


const mapStateToProps = store => ({
    user: store.user
})

const mapDispatchToProps= {
    logged,
    notLoggedIn,
    closedModalLogin
}

export default connect( mapStateToProps, mapDispatchToProps )(Template)


// WEBPACK FOOTER //
// ./src/App/Template/index.js